interface SectionHeaderProps {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  sortType?: "newest" | "popular" | "on_sale" | "featured";
}

const SectionHeader = ({ title, subtitle, children }: SectionHeaderProps) => {
  return (
    <div className="flex justify-between items-center gap-3 mb-6 sm:mb-8 pb-3 sm:pb-4 border-b border-section-border">
      <div className="text-start min-w-0">
        <h2 className="text-2xl sm:text-3xl font-bold text-section-text mb-1 sm:mb-2">{title}</h2>
        <p className="text-section-muted text-sm sm:text-base">{subtitle}</p>
      </div>
      <div className="flex items-center shrink-0">{children}</div>
    </div>
  );
};

export default SectionHeader;
